var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scaling-squares-spinner", style: _vm.spinnerStyle },
    _vm._l(_vm.squaresStyles, function(ss, index) {
      return _c("div", {
        key: index,
        staticClass: "square",
        class: `square-${index + 1}`,
        style: ss
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }